import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { useFormikContext } from 'formik';
import { Tabs } from '../Tabs';
import s from './index.module.scss';

export const InvestmentGroup = ({ children }) => {
  const { t } = useTranslation('calculator');
  const { values, setFieldValue } = useFormikContext();
  return (
    <div className={s.wrapper}>
      <div className={classnames(s.title, 'f-body-accent')}>
        {t('inv_group.investment_group')}
      </div>
      <Tabs
        onChange={value => setFieldValue('group_id', value)}
        selected={values.group_id}
        options={[
          {
            value: 'conservative',
            label: t('inv_group.group_a'),
          },
          {
            value: 'moderate',
            label: t('inv_group.group_b'),
          },
        ]}
      />
      {children}
    </div>
  );
};
